import { render, staticRenderFns } from "./DocumentPlaceholder.vue?vue&type=template&id=fb3d8bca"
import script from "./DocumentPlaceholder.vue?vue&type=script&lang=js"
export * from "./DocumentPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports